import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class DependentExclusionService {
  constructor(client) {
    this.client = client;
  }

  async createDependentsExclusion(payload, token) {
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = await this.client.post(
      `${apiPrefix}${v2}/tickets/dependents-exclusions`,
      payload,
      config
    );
    return response.data;
  }

  async getTicketDependentExclusions(ticketId, token) {
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = await this.client.get(
      `${apiPrefix}${v2}/tickets/${ticketId}/dependent-exclusions`,
      config
    );
    return response.data;
  }

  async getEmployeeActiveCoveragesWithDependents(employeeId, token) {
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = await this.client.get(
      `${apiPrefix}${v2}/employees/${employeeId}/active-coverages-with-dependents`,
      config
    );
    return response.data;
  }

  async getDependentsExclusionTickets(params, { token, signal } = {}) {
    const config = {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
      ...(signal ? { signal } : {})
    };
    const response = await this.client.get(
      `${apiPrefix}${v2}/tickets?${params}`,
      config
    );
    return response.data;
  }

  async patchTicketStatus(ticketId, payload, token) {
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = await this.client.patch(
      `${apiPrefix}${v2}/tickets/${ticketId}/status`,
      payload,
      config
    );
    return response.data;
  }
}
